export default __webpack_public_path__ + "static/media/ConfusionMatrix.5e383f52.png";